/*
 * Builds list: pure model, no React. Which view the list shows (loading, error, empty or rows) and the small
 * derivations the table and the phone cards share.
 */
import type { Platform } from '@hangar/shared';
import type { Build } from '@/api/schemas';

export type ListView = { kind: 'loading' } | { kind: 'error' } | { kind: 'empty' } | { kind: 'ready'; builds: Build[] };

/** Loading and error only show before the first page arrived; with rows in the cache they never replace them. */
export function listView(input: { builds: Build[] | undefined; isLoading: boolean; isError: boolean }): ListView {
  const { builds, isLoading, isError } = input;
  if (isLoading && !builds) return { kind: 'loading' };
  if (isError && !builds) return { kind: 'error' };
  return builds && builds.length > 0 ? { kind: 'ready', builds } : { kind: 'empty' };
}

/** Copy under "No builds yet": a gated Run build points at the CLI, an allowed one at the console. */
export function noBuildsDescription(blockedReason: string | undefined): string {
  return blockedReason
    ? 'Start the first build with hangar build, on your machine or in your CI pipeline: it shows up here live.'
    : 'Run the first build from the console, or let the SDK create one from your CI pipeline (hangar build).';
}

/** Hotfix branches are drawn in the failed tone. */
export const isHotfixBranch = (branch: string | null | undefined): boolean => branch?.startsWith('hotfix/') ?? false;

/** Prefix of the build number: iOS calls it "b" (build), Android "vc" (versionCode). */
export const buildNumberPrefix = (platform: Platform): 'b' | 'vc' => (platform === 'ios' ? 'b' : 'vc');
